/**
 * Helpers for embedding manufacturer how-to videos in medication factsheets.
 *
 * Videos are authored as `MedicationResource` entries with `type: "video"` and
 * a `url`. We only inline-embed YouTube links (the format manufacturers publish
 * injection/mixing guides in); anything else falls back to a tap-out link row.
 */

// 11-char YouTube video id across watch / short / embed / nocookie URL shapes.
const YOUTUBE_ID =
  /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/|live\/)|youtu\.be\/|youtube-nocookie\.com\/embed\/)([A-Za-z0-9_-]{11})/;

/** Extract the YouTube video id from a URL, or null if it isn't a YouTube link. */
export function parseYouTubeId(url: string): string | null {
  if (!url) return null;
  return url.match(YOUTUBE_ID)?.[1] ?? null;
}

/** Poster thumbnail for a YouTube video id (hqdefault always exists). */
export function youTubeThumbnail(id: string): string {
  return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
}

/**
 * Privacy-enhanced (no-cookie) inline embed URL. `autoplay=1` because the
 * player is only mounted after the user taps the poster.
 */
export function youTubeEmbedUrl(id: string): string {
  return `https://www.youtube-nocookie.com/embed/${id}?playsinline=1&rel=0&modestbranding=1&autoplay=1`;
}
